// extracted by mini-css-extract-plugin
export default {"wrap":"Feedback_wrap__Nr9LX","info":"Feedback_info__q+2UN","form":"Feedback_form__bapEQ","row":"Feedback_row__EFT+a","image":"Feedback_image__AptnM"};